import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { clsx } from 'clsx';

type Props = {
    className?: string;
    label?: string;
};

export const RowActionButton: React.FC<Props> = ({ className, label = 'Open details' }) => (
    <span
        className={clsx(
            'inline-flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100',
            className,
        )}
        aria-hidden
        title={label}
    >
        <ArrowUpRight className="h-4 w-4" aria-hidden />
    </span>
);
